import { useState, useContext } from "react";
import Markdown from "markdown-to-jsx";
import { DataContext } from "../../context/DataContext";
import styles from "./ESPWellness.module.css";
import Button from "../../shared/Button/Button";
import Heading from "../../shared/Heading/Heading";
import InputCard from "../../components/InputCard/InputCard";
import AxiosInstance from "../../url/createAxios";
import LoadingContainer from "../../shared/LoadingContainer/LoadingContainer";

const ESPWellness = () => {
  const instance = AxiosInstance();
  const [isChecked, setIsChecked] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [redirectURL, setRedirectURL] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { ESPSpaPage, reservation } = useContext(DataContext);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const handleEmailChange = (_, value) => {
    setEmailValue(value);
    setIsEmailValid(emailRegex.test(value));
  };

  const handleCheckBox = () => {
    setIsChecked(!isChecked);
  }

  const isButtonEnabled = () => {
    return !isLoading && (reservation.EmailAddress || (isChecked && isEmailValid));
  }

  const redirectToESP = (url) => {
    window.open(url, '_blank');
  }
  
  const handleBookButton = async () => {
    setIsLoading(true);
    try {
      const { data } = await instance.post(
        "/esp-spa-page/ESPRedirectURL/",
        {emailAddress: emailValue}, 
        {withCredentials: true});
        
        setRedirectURL(data.redirectURL);
        redirectToESP(data.redirectURL);
    } catch (e) {
        console.error(e.message);
    }

    setIsLoading(false);
  };

  return (
    <>
      <div className={styles.pageWrapper}>
        <section className={styles.container}>
            <div 
              className={styles.contentWrapper}
            >
              <div 
                className={styles.image}
                style={{
                  backgroundImage: `url(${ESPSpaPage.Image?.formats?.medium?.url || ESPSpaPage.Image?.url})`,
                }}
              ></div>
              <div className={styles.content}>
                <Heading
                  txt={ESPSpaPage.Title}
                  paddingTop={"0px"}
                  paddingBottom={"20px"}
                  fontSize={"24px"}
                  fontFamily="Georgia"
                  textTransform="uppercase"
                />
                {ESPSpaPage.Description &&
                  <Markdown>
                    {ESPSpaPage.Description}
                  </Markdown>
                }
                {!isLoading && !redirectURL && ESPSpaPage.EmailInfoText && !reservation.EmailAddress &&
                  <p>{ESPSpaPage.EmailInfoText}</p>
                }
                {!isLoading && !redirectURL && !reservation.EmailAddress &&
                  <InputCard
                    newBoxStyles={{
                      height: "30px",
                      border: "1px solid var(--color-primary)",
                      width: "100%",
                      maxWidth: "350px",
                      marginTop: "10px",
                    }}
                    name={"email"}
                    setFormData={(key, value) => handleEmailChange(key, value)}
                    value={emailValue}
                  />
                }
                {!isLoading && !redirectURL && !reservation.EmailAddress &&
                <div className={styles.checkBoxWrapper}>
                  <div className={styles.checkBox} onClick={handleCheckBox}>
                    {isChecked &&
                      <img src={"/img/info_icons/done_check.svg"} alt={"checked"} />
                    }
                  </div>
                  <Markdown>
                    {ESPSpaPage.ConsentText}
                  </Markdown>
                </div>
                }
                {ESPSpaPage.ButtonText &&
                  <div style={{ marginTop: "25px", position: "relative" }}>
                    <Button
                      txt={ESPSpaPage.ButtonText}
                      backgroundColor={"var(--color-primary)"}
                      color={"var(--color-secondary)"}
                      minHeight="50px"
                      onClick={handleBookButton}
                      newStyles={{
                        paddingBlock: "10px",
                        opacity: isButtonEnabled()
                          ? "1"
                          : "0.4",
                        pointerEvents: isButtonEnabled()
                          ? "auto"
                          : "none",
                      }}
                    />
                    {isLoading &&
                      <LoadingContainer 
                        loaderSize={"30px"} 
                        loaderWrapperStyle={{ 
                          justifyContent: "start",
                          marginLeft: "-16px",
                          position: "absolute"
                        }}
                      />
                    }
                  </div>
                }
              </div>
            </div>
        </section>
      </div>
    </>
  );
};

export default ESPWellness;
